var _style, _circle, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSj(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#D80027;}\n\t.st2{fill:#0052B4;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.8,322.8c14.8,55,47.5,102.6,91.4,136.3V322.8H8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.7,511c7.3,0.6,14.8,1,22.3,1c118.3,0,217.8-80.2,247.2-189.2H233.7V511z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M503.2,189.2C473.8,80.2,374.3,0,256,0c-7.5,0-14.9,0.3-22.3,1v188.2H503.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.2,52.9C56.3,86.6,23.6,134.3,8.8,189.2h91.4C100.2,189.2,100.2,52.9,100.2,52.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M509.8,222.6H200.3l0,0V6.1c-23.7,5.2-46.1,13.7-66.8,25v191.5l0,0H2.2C0.7,233.5,0,244.7,0,256 c0,11.3,0.7,22.5,2.2,33.4h131.4l0,0v191.5c20.7,11.3,43.1,19.8,66.8,25V289.4l0,0h309.5c1.4-10.9,2.2-22.1,2.2-33.4 S511.3,233.5,509.8,222.6L509.8,222.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSj);
export default __webpack_public_path__ + "static/media/sj.aaabb17bbd5f9b8085277b4587cf7e06.svg";
export { ForwardRef as ReactComponent };